import React from "react"
import { FormattedNumber, injectIntl } from "react-intl"
import IntlProps from "../../../state/helpers/IntlProps"
import { RF_METHOD_TYPES } from "./constants"
import { messages } from "./messages"
import "./styles/rainforest-credit-card.scss"

type OwnProps = {
    amount?: number
    currency?: string
    method: RF_METHOD_TYPES
    payBtnColor: string,
}

const RainforestDisabled = (props: OwnProps & IntlProps) => {

    return <>
        <div className="rf-card-network-container">
            <img className="rf-card-network" alt="Rf card network" src="/images/rf_cc/rf_card_network.svg" />
        </div>
        <div className="card-info-container"> 
            <div className="cardholder-name-input-disabled">
                <div className="text-wrapper">{props.intl.formatMessage(messages.cardNumber)}</div>
            </div>
            <div className="group-card-info">
                <div className="month-input-disabled">
                    <div className="text-wrapper">{props.intl.formatMessage(messages.expDate)}</div>
                </div>
                <div className="cvc-input-disabled">
                    <div className="text-wrapper">{props.intl.formatMessage(messages.cvc)}</div>
                </div>
                <div className="zipcode-input-disabled">
                    <div className="text-wrapper">{props.intl.formatMessage(messages.zipCode)}</div>
                </div>
            </div>
        </div>
        {props.method === RF_METHOD_TYPES.PAY_CC ? 
            <div className="pay-button" style={{backgroundColor: props.payBtnColor}}>
                <img className="pay-bag-icon" alt="pay-bag-icon" src="/images/rf_cc/bag.png" />
                <div className="pay-text">
                    {props.intl.formatMessage(messages.pay)}&nbsp;
                    <FormattedNumber
                        value={props.amount}
                        currency={props.currency}
                        style={"currency"}
                    />
                </div>
            </div> :
            <div className="pay-button">
                <img className="pay-bag-icon" alt="pay-bag-icon" src="/images/rf_cc/bag.png" />
                <div className="pay-text">
                    {props.intl.formatMessage(messages.storeDetails)} &nbsp;
                </div>
            </div>
        }
        {props.method === RF_METHOD_TYPES.PAY_CC && 
        <div className="save-card-on-file-container">
            <img className="checkbox-save-card-on-file" alt="checkbox" src="/images/rf_cc/checked_checkbox.png" />
            <div className="text-wrapper">{props.intl.formatMessage(messages.saveCardOnFile)}</div>
        </div>
        }
    </>
}
export default injectIntl(RainforestDisabled)


// WEBPACK FOOTER //
// ./src/common/credit-card/rf-components/RainforestDisabled.tsx